export const navigationBarAccountMenuStyle = {
  loginIcon: {
    height: 30,
    width: "auto",
  },
};
